export const DEVELOPER = 'developer';

export const UPDATE_DEVELOPER = 'update-developer';

export const CREATE_DEVELOPER = 'create-developer';

export const RESET_DEVELOPER_PASSWORD = 'reset-developer-password';

export const CHANGE_DEVELOPER_PASSWORD = 'change-developer-password';

export const RESEND_DEVELOPER_CONFIRMATION_EMAIL = 'resend-developer-confirmation-email';

export enum CreateDeveloperErrorCodes {
  ACCOUNT_ALREADY_REGISTERED = 'ACCOUNT_ALREADY_REGISTERED',
  CPF_ALREADY_IN_USE = 'CPF_ALREADY_IN_USE',
  CNPJ_ALREADY_IN_USE = 'CNPJ_ALREADY_IN_USE',
  SLUG_ALREADY_EXISTS = 'SLUG_ALREADY_EXISTS',
  TEXT_VIOLATION_01 = 'TEXT_VIOLATION_01',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  NET_ERR = 'NET_ERR',
  UNKNOWN = 'UNKNOWN',
}

export enum UpdateDeveloperErrorCodes {
  TEXT_VIOLATION_01 = 'TEXT_VIOLATION_01',
  UNKNOWN = 'UNKNOWN',
}

export enum ChangeDeveloperPasswordErrorCodes {
  INCORRECT_CURRENT_PASSWORD = 'INCORRECT_CURRENT_PASSWORD',
  NET_ERR = 'NET_ERR',
  UNKNOWN = 'UNKNOWN',
}

export enum ResetDeveloperPasswordErrorCodes {
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  NET_ERR = 'NET_ERR',
  UNKNOWN = 'UNKNOWN',
}

export const TEAMMATES_ACCESS_ROLE = 'teammates_access';

export const CREATE_DEVELOPER_BY_INVITE = 'create-developer-by-invite';

export const GET_INVITE = 'get-invite';
